import { ref } from 'vue';
import { defineStore } from 'pinia';
import axios from 'axios';

export const useAssessmentStore = defineStore('assessment', () => {
    const all = ref(null);
    const locale = ref('en');

    const reset = () => {
        all.value = null;
    };

    const actions = {
        search: (params) => axios.get('/api/v1/assessments', { params }),
        storeAssessment: (params) => axios.post('/api/v1/assessments', params),
        updateAssessment: (params) => axios.patch('/api/v1/assessments/' + params.hash, params),
        destroyAssessment: (params) => axios.delete('/api/v1/assessments/' + params.hash),
    };

    const setLocale = (option) => {
        locale.value = option;
        window.axios.post('/set-locale', { locale: option });
    };

    return {
        all,
        locale,
        setLocale,
        reset,
        ...actions,
    };
});
